import { fromJS } from 'immutable';
import { getBrowserSize } from '../common/utils.jsx';
import { getQuestionnaireToken, getQuestionnaireLanguage } from './questionnaire.utils.jsx';
const initialState = {
    fields: {},
    pedigreeGenerated: false,
    pages: {
        currentPageIndex: 0,
        lastPageIndex: 0,
        pageList: [],
        navigationPageList: []
    },
    components: {
        personsArrays: {},
        autocomplete: {
            __storage__: {}
        }
    },
    width: getBrowserSize().width,
    token: getQuestionnaireToken(),
    language: getQuestionnaireLanguage(),
    height: getBrowserSize().height,
    headerLink: 'https://www.invitae.com/en/patients/',
    dataLoaded: false,
    errorText: null
};
export default fromJS(initialState);
